import { render, staticRenderFns } from "./FormControlModulecomponentsCategoryColumn.vue?vue&type=template&id=67d8bdae"
import script from "./FormControlModulecomponentsCategoryColumn.vue?vue&type=script&setup=true&lang=js"
export * from "./FormControlModulecomponentsCategoryColumn.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports